<template>
  <div class="start flex-grow-1 flex-fill">
    <Translate />
    <section class="row">
      <div class="col-4 px-3 py-5 d-none d-md-flex"></div>
      <div class="col-24 col-md-16 px-3 align-items-center d-flex">
        <div class="row align-itens-center">
          <div
            class="col-md-11 min-h text-right justify-content-start align-items-end d-flex flex-column pr-3"
          >
            <img src="../../assets/svg/logo.svg" class="align-self-end mb-2" />
            <h1
              class="title"
              v-text="$ml.get('yourSecurityPlatformAndBugReward')"
            >
              A sua plataforma de segurança e recompensa por bugs
            </h1>
            <p v-text="$ml.get('youWillReceiveReportsFromCommunity')">
              Você recebe feedbacks dos especialistas de segurança da nossa
              comunidade, sem custo adicional, enquanto minimiza as chances de
              expor suas vulnerabilidades na mídia ou redes sociais
            </p>
          </div>
          <div class="col-2 min-h d-none d-md-flex justify-content-center py-3">
            <span class="line align-self-center"></span>
          </div>
          <div
            class="col-24 col-md-11 min-h text-left justify-content-start align-items-end d-flex flex-column mt-5 pl-md-3"
          >
            <div class="card w-100">
              <div class="card-body">
                <h5 v-text="$ml.get('changeAccessPassword')">
                  Alterar senha de acesso
                </h5>
                <p v-if="!required2fa">
                  <font v-text="$ml.get('itHappensInTheBestFamiliesDonotworry')"
                    >Acontece nas melhores famílias! Não se preocupe.</font
                  ><br />
                  <font v-text="$ml.get('fillInTheDetailsBelowTo')"
                    >Preencha os dados abaixo para efetuar a troca de
                    senha.</font
                  >
                </p>
                <p v-else>
                  <font v-text="$ml.get('idConfirmation')"
                    >Falta pouco! Confirme sua identidade para prosseguir com o processo de troca de senha.</font
                  >
                </p>
                <transition name="fade">
                  <div v-show="msgdanger" class="alert alert-danger">
                    {{ msgdanger }}
                  </div>
                </transition>
                <transition name="fade">
                  <div v-show="msgWarning" class="alert alert-warning">
                    {{ msgWarning }}
                  </div>
                </transition>
                <transition name="fade">
                  <div v-show="msgSuccess" class="alert alert-success">
                    <strong v-text="$ml.get('passwordChanged')"></strong><br />
                    <font v-text="$ml.get('youWillBeRedirectedIn')"
                      >Você será redirecionado em</font
                    >
                    {{ seconds }}
                    <font v-text="$ml.get('seconds')">segundos</font>.
                  </div>
                </transition>
                <form @submit.prevent="executeRecaptcha">
                  <div class="row" v-if="!required2fa">
                    <div class="col">
                      <div class="form-group">
                        <input
                          type="password"
                          class="form-control"
                          v-model="password"
                          :placeholder="$ml.get('aNewSuperStrongPassword')"
                          maxlength="200"
                        />
                        <transition v-if="passError" name="fade">
                          <label class="lblError">{{
                            passwordValidation.errorsString
                          }}</label>
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-1" v-if="!required2fa">
                    <div class="col">
                      <div class="form-group">
                        <input
                          type="password"
                          class="form-control"
                          v-model="confPassword"
                          :placeholder="$ml.get('confirmYourPassword')"
                        />
                        <transition name="fade">
                          <label
                            v-if="passError && !$v.confPassword.required"
                            class="lblError"
                            v-text="$ml.get('enterPasswordConfirmation')"
                            >Digite a confirmação da senha</label
                          >
                          <label
                            v-if="passError && !$v.confPassword.sameAsPassword"
                            class="lblError"
                            v-text="$ml.get('passwordsMustMatch')"
                            >As senhas devem ser iguais</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div v-else class="row mb-1">
                    <div class="col">
                      <div class="form-group">
                        <input
                          v-on:keypress="NumbersOnly"
                          type="password"
                          class="form-control"
                          v-model="token2fa"
                          :placeholder="$ml.get('token2fa')"
                          :maxlength="6"
                        />
                        <transition name="fade">
                          <label
                            v-if="error2fa"
                            class="lblError"
                            v-text="$ml.get('invalidCode')"
                            >Código inválido!</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <button
                      :disabled="loadingBtn"
                      class="btn btn btn-lg btn-block"
                    >
                      <Spinner v-show="loadingBtn" />
                      <span v-show="!loadingBtn" v-text="$ml.get('update')">
                        Atualizar
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <recaptcha ref="recaptcha" @verify="resetPassword"></recaptcha>
  </div>
</template>
<script>
import axios from "axios";
import { required, sameAs } from "vuelidate/lib/validators";
import Recaptcha from "../../components/recaptcha.vue";
import Translate from "../../components/translate.vue";
/**
 * Reset Password component
 */
export default {
  page: {
    title: "Recuperação de senha",
    meta: [{ name: "Reset Password" }],
  },
  components: {
    Recaptcha,
    Translate,
  },
  data() {
    return {
      password: "",
      token: "",
      email: "",
      confPassword: "",
      token2fa: "",
      seconds: 5,
      loadingBtn: false,
      passError: false,
      error2fa: false,
      msgdanger: "",
      msgWarning: "",
      msgSuccess: "",
      rules: [
        { message: "aNumber", regex: /[0-9]+/ },
        { message: "anUppercaseLetter", regex: /[A-Z]+/ },
        { message: "aLowercaseLetter", regex: /[a-z]+/ },
        { message: "atLeastCharacters", regex: /.{6,}/ },
      ],
      required2fa: false,
    };
  },
  validations: {
    confPassword: {
      required,
      sameAsPassword: sameAs("password"),
    },
  },
  computed: {
    passwordValidation() {
      let errorsString = "";
      for (let condition of this.rules) {
        if (!condition.regex.test(this.password)) {
          errorsString = errorsString + this.$ml.get(condition.message);
        }
      }
      return { errorsString };
    },
  },
  mounted() {
    this.$v.$reset();
    this.token = this.$route.query.key;
    this.email = this.$route.query.email;
  },
  methods: {
    // execute the recaptcha widget
    executeRecaptcha() {
      this.$refs.recaptcha.execute();
    },

    resetPassword(tokenRecaptcha) {
      this.$v.$touch();

      if (this.$v.$invalid || this.passwordValidation.errorsString) {
        this.passError = true;
        return;
      }

      if (this.password != this.confPassword) {
        this.msgWarning = "As senhas não são iguais!";
        return;
      }

      this.passError = false;
      this.loadingBtn = true;
      this.msgdanger = "";
      this.msgWarning = "";
      this.msgSuccess = "";

      // stop here if form is invalid
      this.$v.$touch();

      var self = this;
      delete axios.defaults.headers.common["Authorization"];
      axios
        .put(this.$store.getters["getApiUrl"] + `account/reset-password`, {
          email: this.email,
          newPassword: this.password,
          token: this.token,
          tokenRecaptcha: tokenRecaptcha,
          code: this.token2fa == "" ? undefined : this.token2fa,
        })
        .then(function (response) {
          self.msgSuccess = response.data.msg;
          self.msgSubSuccess = true;

          var refreshInterval = setInterval(() => {
            if (self.seconds > 0) {
              self.seconds = self.seconds - 1;
            } else {
              clearInterval(refreshInterval);
              self.msgSubSuccess = false;
              self.loadingBtn = false;
              self.$router.push({
                name: "login",
                params: {
                  email: self.email,
                },
              });
            }
          }, 1000);
        })
        .catch((error) => {
          self.loadingBtn = false;
          const message = error.response.data.message;

          if (message === "O código do autenticador não é válido!") {
            this.required2fa = true;
            this.error2fa = this.token2fa ? true : false;
          }
          // self.msgdanger = self.$ml.get("unableToCompleteThisRequest");
        });
    },

    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

  },
};
</script>
<style scoped>
.btnForm {
  width: 173px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.lblError {
  font-size: 11px;
  padding-left: 5px;
  color: red;
  position: absolute;
}
.form-group {
  margin-bottom: 20px;
}
</style>
